import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { DeleteHarvestUnitComponent } from '../delete-harvest-unit/delete-harvest-unit.component';

@Component({
  selector: 'app-harvest-unit',
  templateUrl: './harvest-unit.component.html',
  styleUrls: ['./harvest-unit.component.scss'],
})
export class HarvestUnitComponent implements OnInit {
  addUnitForm: FormGroup;
  unitDataList: any = [];
  selectedItems: any = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private _userService: UserManagementService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<HarvestUnitComponent>
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.getManageUnit();
  }

  formInIt() {
    this.addUnitForm = this.fb.group({
      unitName: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      date: [new Date()],
    });
  }

  getManageUnit() {
    this._userService.getUnitList().subscribe((data: any) => {
      this.unitDataList = data.result.data;
    });
  }

  onClear() {
    console.log('clear is working.');
    this.dialogRef.close();
    this.router.navigate(['/add-harvest-crop']);
  }

  onSubmit() {
    if (this.addUnitForm.invalid) {
      this.toastr.warning('Please fill unit name');
      return false;
    } else {
      let body = {
        unitName: this.addUnitForm.value.unitName,
      };
      this._userService.addManageUnit(body).subscribe((data) => {
        if (data['result'].data == 1) {
          this.toastr.success(data['result'].message);
          this.addUnitForm.reset();
          this.getManageUnit();
        } else {
          this.toastr.error(data['result'].message, 'Error', {
            timeOut: 3000,
          });
        }
      });
    }
  }

  deleteUnit() {
    if (this.selectedItems?.length > 0) {
      var postdata = {
        removeUnitList: this.selectedItems,
      };
      this._userService.getActiveUnit(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteHarvestUnitComponent, {
            width: '45%',
            height: 'auto',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                delete ele.unitName;
              });
              const deleteBody = {
                removeUnitList: this.selectedItems,
              };
              this._userService
                .removeManageUnit(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message, 'Success', {
                      timeOut: 3000,
                    });
                    this.selectedItems = [];
                    this.getManageUnit();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one Unit!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  itemToDelete(unitItems, event: Event) {
    if (this.selectedItems?.find((x) => x == unitItems)) {
      this.selectedItems?.splice(this.selectedItems?.indexOf(unitItems), 1);
    } else {
      this.selectedItems?.push(unitItems);
    }
  }
}
